import { Link } from 'react-router-dom'
import { SITE } from '../data/site.js'

export default function Privacy() {
  return (
    <main className="container page page-narrow">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>Privacy Policy</span></nav>
      <header className="page-head">
        <h1>Privacy Policy</h1>
        <p>Last updated: 8 August 2026</p>
      </header>

      <section className="prose policy">
        <p>
          {SITE.legalName} ({SITE.abn}) ("we", "us", "our") is committed to protecting your personal
          information in accordance with the Australian Privacy Act 1988 (Cth) and the Australian
          Privacy Principles (APPs).
        </p>

        <h2>1. Information we collect</h2>
        <p>We collect only the personal information needed to supply our products:</p>
        <ul>
          <li>Name and contact details (phone number, email address, delivery address)</li>
          <li>Order history and product preferences</li>
          <li>Communications you send us by email, phone or through the website</li>
          <li>Basic technical data such as IP address and browser type when you visit our website</li>
        </ul>
        <p>
          We do not collect or store payment card details. Card payments are processed by Stripe, a PCI
          DSS compliant payment provider — card data goes directly to Stripe and never touches our
          systems. Bank transfers are made through your own bank.
        </p>

        <h2>2. How we use your information</h2>
        <ul>
          <li>To process and fulfil orders, and arrange pickup or delivery</li>
          <li>To communicate with you about your order and verify payments</li>
          <li>To issue tax invoices and comply with our legal obligations</li>
          <li>To respond to enquiries and provide customer support</li>
          <li>To improve our website and service</li>
        </ul>
        <p>
          We will not use your personal information for direct marketing without your consent, and we
          never sell or rent your personal information to anyone.
        </p>

        <h2>3. How we share your information</h2>
        <p>We only share information where needed to serve you:</p>
        <ul>
          <li>Stripe, to process card payments</li>
          <li>Delivery providers, to deliver your order</li>
          <li>IT service providers that host our website and systems</li>
          <li>Government agencies or law enforcement where required by law</li>
        </ul>

        <h2>4. Storage and security</h2>
        <p>
          Personal information is stored electronically on secure systems. We take reasonable steps to
          protect it from misuse, loss and unauthorised access, though no internet-based service can
          guarantee absolute security.
        </p>

        <h2>5. Cookies and local storage</h2>
        <p>
          Our website does not use advertising or tracking cookies. We use your browser's local storage
          only to remember your shopping cart between visits. Clearing your browser data removes it.
        </p>

        <h2>6. Accessing and correcting your information</h2>
        <p>
          You may request access to the personal information we hold about you, or ask us to correct it,
          by contacting <a href={`mailto:${SITE.email}`}>{SITE.email}</a> or{' '}
          <a href={SITE.phoneHref}>{SITE.phone}</a>. We respond within a reasonable timeframe
          (generally 30 days).
        </p>

        <h2>7. Retention</h2>
        <p>
          We retain personal information for as long as necessary to provide our services and to meet
          legal obligations, including Australian tax record-keeping requirements. When it is no longer
          needed, we securely delete or de-identify it.
        </p>

        <h2>8. Third-party websites</h2>
        <p>
          Our website may link to third-party websites. We are not responsible for their privacy
          practices and encourage you to read their policies.
        </p>

        <h2>9. Changes to this policy</h2>
        <p>
          We may update this Privacy Policy from time to time; the current version will always be
          available on this page. Continued use of the website after an update constitutes acceptance
          of the revised policy.
        </p>

        <h2>10. Contact and complaints</h2>
        <p>
          If you have a privacy concern or complaint, contact us first so we can resolve it:{' '}
          <a href={`mailto:${SITE.email}`}>{SITE.email}</a> · <a href={SITE.phoneHref}>{SITE.phone}</a>.
          If you are not satisfied with our response, you may contact the Office of the Australian
          Information Commissioner (OAIC) at oaic.gov.au.
        </p>

        <p className="muted">{SITE.legalName} · {SITE.abn} · {SITE.address}</p>
      </section>
    </main>
  )
}
